import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "onClear", "value"];
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Search = _ref => {
  let {
      onChange,
      onClear,
      value
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleOnChange = event => {
    if (event.target instanceof HTMLInputElement) {
      onChange(event.target.value);
    } else {
      onClear();
    }
  };
  return /*#__PURE__*/_jsx(SearchInput, Object.assign({}, rest, spacingProps, {
    onChange: handleOnChange,
    value: value
  }));
};
const SearchWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
SearchWrapper.displayName = 'InputWrapper';
Search.Wrapper = SearchWrapper;